import mutations from './mutations';
import getters from './getters';
import actions from './actions';

export default {
  namespaced: true,
  state: {
    statisticsConsultations: [],
    statisticsConsultationsCommon: {},
    statisticsService: [],
    statisticsServiceCommon: {},
  },
  actions,
  getters,
  mutations,
};
